import { render, staticRenderFns } from "./Created.vue?vue&type=template&id=7b368fd4&scoped=true&"
import script from "./Created.vue?vue&type=script&lang=js&"
export * from "./Created.vue?vue&type=script&lang=js&"
import style0 from "./Created.vue?vue&type=style&index=0&id=7b368fd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b368fd4",
  null
  
)

export default component.exports